export enum AuthErrorCode {
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED'
}